// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__55ziG","change":"styles_change__c7mLZ","ic":"styles_ic__-jngu"};